// ============================================================
// 套餐与订阅页（DW 反馈修复）：发布弹窗「升级尊享版 立即查看」等促销位统一跳转
// 复用 PlanCard（当前套餐/升级/续费/支付），确保任何入口不再是空页面
// ============================================================
import { Typography } from 'antd';
import PlanCard from '../components/payment/PlanCard';

const { Title, Paragraph } = Typography;

export default function Pricing() {
  return (
    <div data-testid="pricing-page" style={{ maxWidth: 1080, margin: '24px auto', padding: '0 16px' }}>
      <Title level={3} style={{ marginBottom: 4 }}>
        套餐与订阅
      </Title>
      <Paragraph type="secondary" style={{ marginBottom: 16 }}>
        升级后解锁更多发布产物（部署文件 / EXE / 边缘包 / 资产包 / AI 模型包 / 离线 U 盘包）、去除水印并提升并发与额度。
      </Paragraph>
      <PlanCard />
    </div>
  );
}
